import axios from 'axios';
import environment from '@src/environment';

export const state = {
  unplannedMealsMap: [],
};

export const getters = {
  cachedMeal: (state) => {
    const map = {};
    if (state.unplannedMealsMap) {
      state.unplannedMealsMap.forEach((meal) => {
        map[meal.id] = meal;
      });
    }
    return map;
  },
};

export const mutations = {
  pushMeal(state, value) {
    state.unplannedMealsMap.push(value);
  },
};

export const actions = {
  async getMeal(ctx, id) {
    return await axios
      .get(`${environment.MEALS_URL}/${id}/details?isPremium=true`)
      .then((res) => {
        res.data.dishType = 'm';
        res.data.recipes = res.data.recipes.map((recipe) => {
          return {
            ...recipe,
            dishType: 'r',
          };
        });
        ctx.commit('pushMeal', res.data);
        return res.data;
      })
      .catch((err) => console.log(err));
  },
};
